import script from "./send-us-a-message.vue?vue&type=script&setup=true&lang=js"
export * from "./send-us-a-message.vue?vue&type=script&setup=true&lang=js"

import "./send-us-a-message.vue?vue&type=style&index=0&id=1eaf86f2&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eaf86f2"]])

export default __exports__